export const validateEmail = (email) => {
    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

// null checker
export function hasNull(target) {
    for (var member in target) {
        if (target[member] === null) {
            return true;
        } else if (target[member] === '') {
            return true;
        }
    }
    return false;
}

export const isEmptyObject = (obj) => Object.keys(obj).length === 0 && obj.constructor === Object;

export async function reduceImageFileSize(base64Str, MAX_WIDTH = 450, MAX_HEIGHT = 450) {
    let resized_base64 = await new Promise((resolve) => {
        let img = new Image();
        img.src = base64Str;
        img.onload = () => {
            let canvas = document.createElement('canvas');
            let width = img.width;
            let height = img.height;

            if (width > height) {
                if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width;
                    width = MAX_WIDTH;
                }
            } else {
                if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height;
                    height = MAX_HEIGHT;
                }
            }
            canvas.width = width;
            canvas.height = height;
            let ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            resolve(canvas.toDataURL()); // this will return base64 image results after resize
        };
    });
    return resized_base64;
}

export const BASE_URL = process.env.REACT_APP_API_URL;

export const isUserAuthenticated = (user, pathname) => {
    if (user && pathname === '/') {
        return window.location.replace('/dashboard/applicants');
    }
    if (!user && pathname === '/') {
        return window.location.replace('/login');
    }

    if (!user && pathname === '/dashboard/*') {
        return window.location.replace('/login');
    }

    if (user && pathname === '/login') {
        return window.location.replace('/dashboard/applicants');
    }

    if (user && pathname === '/register') {
        return window.location.replace('/dashboard/applicants');
    }
};

export const gotoLocation = (url) =>
    window.location.replace(`${process.env.REACT_APP_APP_URL}/${url}`);

export const GETRequest = async (endpoint) => {
    try {
        const response = await fetch(`${BASE_URL}/api/v1/${endpoint}`);
        return await getResponse(response);
    } catch (e) {
        console.log('ERROR: ', e);
    }
};

export const POSTRequest = async (endpoint, values) => {
    try {
        const response = await fetch(`${BASE_URL}/api/v1/${endpoint}`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(values),
        });
        return await getResponse(response);
    } catch (e) {
        console.log('ERROR: ', e);
    }
};

export const AuthenticatedGETRequest = async (endpoint) => {
    try {
        const response = await fetch(`${BASE_URL}/api/v1/${endpoint}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        return await getResponse(response);
    } catch (e) {
        console.log('ERROR: ', e);
    }
};

export const AuthenticatedPOSTRequest = async (endpoint, values) => {
    try {
        const response = await fetch(`${BASE_URL}/api/v1/${endpoint}`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify(values),
        });
        return await getResponse(response);
    } catch (e) {
        return e;
    }
};

export const AuthenticatedPUTRequest = async (endpoint, values) => {
    try {
        const response = await fetch(`${BASE_URL}/api/v1/${endpoint}`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify(values),
        });
        return await getResponse(response);
    } catch (e) {
        return e;
    }
};

export const AuthenticatedDELETERequest = async (endpoint) => {
    try {
        const response = await fetch(`${BASE_URL}/api/v1/${endpoint}`, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        return await getResponse(response);
    } catch (e) {
        return e;
    }
};

export const generateAuthTokens = async (accessToken, refreshToken) => {
    try {
        const response = await fetch(`${BASE_URL}/api/v1/refresh_token`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({
                refresh_token: String(refreshToken),
            }),
        });
        const payload = await getResponse(response);
        const { data } = payload;
        return data;
    } catch (e) {
        return e;
    }
};

const getResponse = async (response) => {
    if (!response.ok) {
        if (response.status === 200 || response.status === 201) {
            return response.json();
        } else if (response.status === 401) {
            throw new Error('براہ کرم سسٹم میں دوبارہ لاگ ان ہوں۔');
        } else if (response.status === 403) {
            throw new Error('براہ کرم سسٹم میں دوبارہ لاگ ان ہوں۔');
        }
    }
    return response.json();
};
